import React from 'react';

import giftCardIcon from '../../../@active-configuration/assets/prepaid-card-icon.svg';

export const Prepaid = () => <img src={giftCardIcon} alt="Gift Card icon" />;
